module.exports = __webpack_public_path__ + "static/back-blog-2757707cbf155e904d5aae4e8daa0351.png";